import React from 'react';
import './styles.scss';
import { APP_TEXTS } from '@texts';

const Spinner = (props) => (
  <div className={`spinner ${props && props.extraClass}`}>
    <div className="spinner__loader">{APP_TEXTS.LABEL_SPINNER_LOADING.Content}...</div>
  </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/LoadingStyles/Spinner.js